export const RENDER_BYTES = (bytes: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let size = bytes;
  let unitIndex = 0;
  while (size >= UNIT && unitIndex < units.length - 1) {
    size /= UNIT;
    unitIndex++;
  }
  return `${size} ${units[unitIndex]}`;
};

export const UNIT = 1024;

export const KB = UNIT;

export const MB = KB * UNIT;
